import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { HttpEventType } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { CompareserviceService } from '../compareservice.service';
import { ConfigPopupComponent } from '../config-popup/config-popup.component';
import { DataService } from 'src/app/features/dfte-grid-view/config/data.service';
import { InfoPopupComponent } from 'src/app/shared/components/info-popup/info-popup.component';
import { NotificationService } from 'src/app/shared/components/notification/notification.service';
import { DconConfigAPI } from 'src/app/features/dfte-grid-view/config/config';

@Component({
  selector: 'app-createsubmit',
  templateUrl: './createsubmit.component.html',
  styleUrls: ['./createsubmit.component.scss']
})
export class CreatesubmitComponent implements OnInit {
  selectedStartDate: string;
  startDate1 = new Date();
  configDateNew: any = [];
  startDate = new FormControl(new Date());
  tomorrow = new Date();
  endDate = new FormControl(new Date());
  dateVariable = true;
  selectedInstance: string;
  date: any;
  public itemNumber = 0;
  public progressBarName = 'select';
  public fileName1 = 'Use default template / BR100 file';
  public fileName2 = 'Upload Workbook file';
  selectedValue: string;
  public sourceVal = [];
  configItem: any = [];
  public tracks = [];
  public tasks = [];
  targetInstance: any;
  batchKey: string;
  public configData = [];
  public configData1 = [];
  showArray = [];
  showArray1 = [];
  showArray2: any = [];
  modules: any = [];
  instanceList: any;
  trackName: any;
  configData2: any = [];
  endDateReadonly = true;
  public submitNewBtnDisable: boolean = false;
  selectedEndDate: string;
  configTemplate = false;
  selected: any = [];
  selectedModule: any = [];
  isChecked: boolean = false;
  selectedFiles: any;
  fileName: any;
  fileUpload: string;
  fileUpload1: string;
  selectedRadioValue: any;
  radioSelected: string;
  fileUploaded: any = [];
  file: any = [];
  files: any[] = [{ WorkBook_Template: "Y", name: 'Use default template / BR100 file', checked: 'true' }, { WorkBook_Template: "N", name: 'Upload Workbook file', checked: 'false' }];
  submit: boolean = true;
  selOpt: boolean = true;
  public progressBarArray1 = [{ name: "select", src: 'assets/select.png', index: 0 },
  { name: "submit", src: 'assets/submit.png', index: 1 },
  { name: "create", src: 'assets/create.png', index: 2 },
  ];


  hideOptions: boolean = true;
  isDisabled: boolean = true;
  start: any;
  selectedFile: any;
  batchStatus: any;
  events: string[] = [];
  end: any;

  uploadForm: FormGroup;
  submitDisable: boolean = true;
  editBtnDisable: boolean = false;
  type: string = '';
  constructor(public dialog: MatDialog, private formBuilder: FormBuilder
    , public _data: DataService,
    private compareService: CompareserviceService,
    private router: Router,
    private route: ActivatedRoute,
    private notification: NotificationService) {
    this.tomorrow.setDate(this.tomorrow.getDate());
    this.fileName1 = 'Use default template / BR100 file';
    this.getWorkbookConfigDetails();


  }

  ngOnInit(): void {
    if (this.compareService.projId == null) {
      this.router.navigate([""], { relativeTo: this.route });
    } else {
      this.submitDisable = true;
      this.batchKey = this.compareService.batchKey;
      this.batchStatus = this.compareService.batchStatus;
      this.uploadForm = this.formBuilder.group({
        fileData: [""],
      });
    }
  }

  configPopUp(data, i) {
    const dialogRef = this.dialog.open(ConfigPopupComponent, {
      width: "927px",
      height: "620px",
      data: {
        configData: Object.assign({}, data),
      },
    });

    dialogRef.afterClosed().subscribe((result) => {

      this.compareService.selectDateValue = new Date(this.selectedStartDate);
      this.compareService.endDateValue = new Date(this.selectedEndDate);
      this.compareService.instanceName = this.selectedInstance;
      this.compareService.targetInstance = this.targetInstance;
      this.compareService.instanceList = this.instanceList;
      if (result.savedData) {
        this.setSelectedconfigData(result, this.configDateNew, i);
        this.compareService.configObj = {
          tracks: this.tracks,
          configData: this.configDateNew,
        };
        if (this.type === 'edit') {
          this.submit = true;
          this.type = '';
        }
        this.submitDisable = this.getLineItems(this.configDateNew).length > 0 ? false : true;
        this.compareService.tabval.next("createSubmit");
        this.router.navigate(["../createSubmit"], { relativeTo: this.route });
      } else {
        this.compareService.configObj = {
          tracks: this.tracks,
          configData: this.configDateNew,
        };
      }
    });
  }

  setSelectedconfigData(result, configObj, i) {
    const selConfigData = result.selectedConfigData;
    configObj.forEach((element, index) => {
      if (selConfigData.TRACK == element.TRACK && selConfigData.APPLICATION == element.APPLICATION && selConfigData.APPLICATION_SHORT_CODE == element.APPLICATION_SHORT_CODE) {
        this.configDateNew.splice(index, 1, selConfigData);
      }
    });

    if (!this.configDateNew[i].saveStatus) {
      this.showArray2[i] = false;
      this.configDateNew[i].defaultTemplate = true;
      this.configDateNew[i].fileName = "No File Choosen";
    }
  }


  getWorkbookConfigDetails() {
    const data = [];
    this.batchKey = this.compareService.batchKey;
    this.compareService.getWorkbookConfigDetails(this.batchKey).subscribe((res) => {
      res?.Config_Details?.forEach((element) => {
        let task = [];
        const obj = JSON.parse(element.details);
        if (obj.TASK != null) {
          obj.TASK.forEach((ele) => {
            const taskObj = ele;
            taskObj["selectStatus"] = "y";
            task.push(taskObj);
          });
        } else {
          task = null;
        }
        const detailsObj = {
          TRACK: obj.TRACK,
          APPLICATION: obj.APPLICATION,
          APPLICATION_SHORT_CODE: obj.APPLICATION_SHORT_CODE,
          saveStatus: true,
          saveStatus1: false,
          TASK: task,
          fileName: 'No File Choosen',
          defaultTemplate: true
        };
        data.push(detailsObj);
      });
      this.configData = data;
      data.forEach((element, index) => {
        this.tracks.push(element.TRACK);
        this.configData.forEach((element1) => {
          this.configData1.push(element.APPLICATION);
          this.trackName = element1.TRACK;
        });


      });
      this.tracks = [...new Set(this.tracks)];
      this.setShowArray();
      this.configDateNew = [...new Map(this.configData.map(obj => [JSON.stringify(obj), obj])).values()];
      this.submitDisable = this.getLineItems(this.configDateNew).length > 0 ? false : true;


    });
  }

  setShowArray() {
    this.tracks.forEach((val, index) => {
      this.showArray[index] = false;
    });
  }

  workbookPopup() {
    const dialogRef = this.dialog.open(InfoPopupComponent, {
      width: "917px",
      height: "220px",
      data: {
        type: 'Task Status',
        mess: `Batch Key ${this.compareService.batchKey}: <b>Config Workbook - Process Submitted</b>`,
        estimatedTime: `Estimated execution time ${this.calculateSelectedTasks() * 2} minutes`
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result = 'ok') {
        dialogRef.close('ok');
        this._data.apiCallInProgress = false;
        this._data.workbookCreated = true;
        document.getElementById("overlay").style.display = "none";
        this.router.navigate(["/config-workbook"]);
      }
    });
  }

  calculateSelectedTasks() {
    let totalSelectedTask = 0;
    this.configDateNew.forEach((config) => {
      if (config.saveStatus) {
        totalSelectedTask = totalSelectedTask + config.TASK.filter((elem) => elem.selectStatus === "y").length;
      }
    });
    return totalSelectedTask;
  }


  getSelectedItem(item, i, arg1) {
    this.configData2 = [];
    if (this.fileName1 === 'Use default template / BR100 file') {
      this.fileUploaded = this.fileUploaded.filter(e => e !== item);
      this.selectedFiles = 'Y';
      this.showArray2[i] = false;
      this.file = item + '_Workbook.xlsx';
      this.modules.push({
        name: item,
        action: {
          "Track": arg1,
          "Application_Name": item,
          "WorkBook_Template": this.selectedFiles,
          "Filename": this.file,
        },
      });
      this.modules.forEach((element, index) => {
        this.configData2.push(element.action);
      });
    }
    else {
      this.selectedFiles = 'N';
      this.showArray2[i] = true;
      this.file = null;
      this.modules.push({
        name: item,
        action: {
          "Track": arg1,
          "Application_Name": item,
          "WorkBook_Template": this.selectedFiles,
          "Filename": this.file,
        },
      });
      this.modules.forEach((element, index) => {
        this.configData2.push(element.action);
      });
    }
    if ((this.configData2.filter(e => e.WorkBook_Template === 'N')).length ===
      this.fileUploaded.length) {
      this.submitNewBtnDisable = false;
    } else {
      this.submitNewBtnDisable = true;
    }
  }


  createPopup() {
    const dialogRef = this.dialog.open(InfoPopupComponent, {
      width: "917px",
      height: "220px",
      data: {
        type: 'Upload Status',
        mess: `<b>File uploaded successfully</b>`,
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result = 'ok') {
        this._data.apiCallInProgress = false;
        document.getElementById("overlay").style.display = "none";
      }
    });
  }

  // when checkbox change, add/remove the item from the array
  onChange(event, item, arg, i) {
    this.selectedRadioValue = item;
    if (event.checked === true) {
      this.selected.push(item);
      this.getSelectedItem(item, i, arg);

    } else {
      this.configData2.splice(this.configData2.findIndex((e) => e.Application_Name === item), 1);
      this.modules.splice(this.modules.findIndex((e) => e.name === item), 1);
      this.showArray1[i] = false;
      if (this.configData2.length === 0) {
        this.submitNewBtnDisable = true;
      } else {
        const uploadFileModules = this.configData2.filter(e => e.WorkBook_Template === 'N');
        //no more modules with upload options
        if (uploadFileModules.length === 0) {
          this.fileUploaded = [];
          this.submitNewBtnDisable = false;
        }
      }

    }
  }

  radioChange(event, item, arg, i, arg1) {
    this.fileUpload = arg;
    this.configData2 = [];
    //default template
    if (event.target.checked === true && arg === 'Use default template / BR100 file') {
      this.configDateNew[i].fileName = 'No File Choosen';
      this.configDateNew[i].defaultTemplate = true;
      this.fileUploaded = this.fileUploaded.filter(e => e !== item);
      this.selectedFiles = 'Y';
      this.showArray2[i] = false;
      this.file = item + '_Workbook.xlsx';
      if (this.modules.length > 0) {
        if (this.modules.findIndex(e => e.name === item) > -1) {
          this.modules.splice(this.modules.findIndex(e => e.name === item), 1);
        }
        this.modules.push({
          name: item,
          action: {
            "Track": arg1,
            "Application_Name": item,
            "WorkBook_Template": this.selectedFiles,
            "Filename": this.file,
          },
        });
        this.modules.forEach(element => {
          this.configData2.push(element.action);
        });

      } else {
        this.modules.push({
          name: item,
          action: {
            "Track": arg1,
            "Application_Name": item,
            "WorkBook_Template": this.selectedFiles,
            "Filename": this.file,
          },
        });
        this.modules.forEach(element => {
          this.configData2.push(element.action);
        });
      }
      if ((this.configData2.filter(e => e.WorkBook_Template === 'N')).length ===
        this.fileUploaded.length) {
        this.submitNewBtnDisable = false;
      } else {
        this.submitNewBtnDisable = true;
      }
    }//user uploaded file
    else {
      this.configDateNew[i].defaultTemplate = false;
      this.submitNewBtnDisable = true;
      this.selectedFiles = 'N';
      this.showArray2[i] = true;
      this.file = null;
      if (this.modules.length > 0) {
        if (this.modules.findIndex(e => e.name === item) > -1) {
          this.modules.splice(this.modules.findIndex(e => e.name === item), 1);
        }
        this.modules.push({
          name: item,
          action: {
            "Track": arg1,
            "Application_Name": item,
            "WorkBook_Template": this.selectedFiles,
            "Filename": this.file,
          },
        });

        this.modules.forEach(element => {
          this.configData2.push(element.action);
          this.configData2 = [...new Map(this.configData2.map(obj => [JSON.stringify(obj), obj])).values()];
        });

      } else {
        this.modules.push({
          name: item,
          action: {
            "Track": arg1,
            "Application_Name": item,
            "WorkBook_Template": this.selectedFiles,
            "Filename": this.file,
          },
        });
        this.modules.forEach(element => {
          this.configData2.push(element.action);
        });
      }
    }
  }


  onFileSelected(event, application, indexVal) {
    const format = ["xlsx"];
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.configDateNew[indexVal].fileName = file.name;
      this.uploadForm.get("fileData").setValue(file);
    }
    const fileFormat = (event.target.files[0].name).substr((event.target.files[0].name).lastIndexOf('.') + 1);
    if (!format.includes(fileFormat)) {
      event.target.value = null;
      this.fileUploaded = this.fileUploaded.filter(e => e !== application);
      this.submitNewBtnDisable = true;
      this.notification.showError("Not a valid file format, xlsx file required");
    } else {
      //push application on file upload
      this.fileUploaded = this.fileUploaded
        .filter(e => e !== application)
        .concat([application]);
      //set disabled if uploaded file count not same as required workbook upload count
      if ((this.configData2.filter(e => e.WorkBook_Template === 'N')).length ===
        this.fileUploaded.length) {
        this.submitNewBtnDisable = false;
      } else {
        this.submitNewBtnDisable = true;
      }
      this.uploadFile(application);
    }
  }

  async uploadFile(application) {
    this._data.apiCallInProgress = true;
    document.getElementById("overlay").style.display = "block";
    const formData = new FormData();
    formData.append("batchkey", this.batchKey);
    formData.append("path", `${this._data.windowFileSharePath}${this._data.projectID}\\${DconConfigAPI.APPLICATION.toUpperCase()}\\`);
    formData.append("module", application);
    formData.append("csvExtract", "false");
    formData.append("fileData", this.uploadForm.get("fileData").value);

    await (await this.compareService.uploadFileFromSFTP(formData)).subscribe(async (message) => {
      switch (message.type) {
        case HttpEventType.Response:
          this._data.apiCallInProgress = false;
          document.getElementById("overlay").style.display = "none";
          this.createPopup();
          break;

      }
    },
      error => {
        this.submitNewBtnDisable = true;
        this._data.apiCallInProgress = false;
        document.getElementById("overlay").style.display = "none";
        this.notification.showError("Failed to upload workbook");
      });
  }
  addEvent() {
    this.endDateReadonly = false;
  }



  onWorkbookSubmit() {
    this._data.apiCallInProgress = true;
    document.getElementById("overlay").style.display = "block";

    const body = {
      "LineItems": this.preparePayLoad(),
    };
    this.compareService.onWorkbookUpdate(body).subscribe((res) => {
      if (res.Result === 'SUCCESS') {
        this._data.apiCallInProgress = true;
        document.getElementById("overlay").style.display = "block";
        const body1 = {
          "batchkey": this.compareService.batchKey,
          "requesttype": DconConfigAPI.API_VARIABLES.Request_Type_ConfigWorkbook,//"CONFIG WORKBOOK",
          "processtrigger": "Y"
        };
        this.compareService.onGenerateUpdate(body1).subscribe((resp) => {
          this.onSubmitForWorkbook();
        });

      } else {
        this._data.apiCallInProgress = false;
        document.getElementById("overlay").style.display = "none";
        this.notification.showError("Failed to generate workbook");
      }


    },
      (error) => {
        this._data.apiCallInProgress = false;
        document.getElementById("overlay").style.display = "none";
        this.notification.showError("Failed to generate workbook");
      });
  }

  preparePayLoad() {
    const body = [];
    this.configDateNew.forEach((ele, i) => {
      if (ele.saveStatus) {
        const obj = {
          Application_Name: ele.APPLICATION,
          Filename: ele.defaultTemplate ? ele.APPLICATION + "_Workbook.xlsx" : null,
          Track: ele.TRACK,
          WorkBook_Template: ele.defaultTemplate ? "Y" : "N"
        }
        body.push(obj);
      };
    });
    return body;
  }

  async onSubmitForWorkbook() {
    this._data.apiCallInProgress = true;
    document.getElementById("overlay").style.display = "block";
    await (await this.compareService.onSubmit(this.batchKey)).subscribe(async (message) => {
      switch (message.type) {
        case HttpEventType.Response:
          this.workbookPopup();
          this._data.apiCallInProgress = false;
          document.getElementById("overlay").style.display = "none";
          break;
      }

    },
      error => {
        this._data.apiCallInProgress = false;
        document.getElementById("overlay").style.display = "none";
        this.notification.showError("Failed to generate workbook");
      });
  }

  onSubmit() {
    const body = this.onConfigSubmit();
    this.compareService.Submit(body).subscribe((res) => {
      this.submit = false;
      this.editBtnDisable = false;
      this.setShowArray();
      this.submitNewBtnDisable = this.getLineItems(this.configDateNew).length > 0 ? false : true;
    },
      (error) => {
        this.notification.showError('Something went wrong!');
      });
  }

  onConfigSubmit() {
    const body = {
      batchkey: this.compareService.batchKey ? this.compareService.batchKey : "",
      projectname: this.compareService.projId,
      requestedby: this.compareService.requestedBy,
      // instanceid : "99",
      filesharepath: this.compareService.getfileSharePath(),//"\\\\usazuconde00173\\DFTE\\",
      requesttype: DconConfigAPI.API_VARIABLES.Request_Type_ConfigWorkbook,
      LineItems: this.getLineItems(this.configDateNew)
    };
    return body;
  }

  getLineItems(configData) {
    const data = [];
    configData?.forEach((element) => {
      if (element.TASK != null && element.saveStatus) {
        element.TASK.forEach((ele) => {
          if (ele.selectStatus === "y") {
            const trackObj = {
              track: element.TRACK,
              applicationshortcode: element.APPLICATION_SHORT_CODE,
              taskname: ele.TASK_NAME,
              taskcode: ele.TASK_CODE,
              Old_batchKey: ele.Old_batchKey
              // instanceid : ele.InstanceId
            };
            data.push(trackObj);
          }
        });
      }
    });
    return data;
  }

  editConfig() {
    this.tracks.forEach((val1, index) => {
      this.configDateNew.forEach((val2, index2) => {
        if (val1 === val2.TRACK && val2.saveStatus) {
          this.showArray[index] = true;
        }
      });
    });

    this.editBtnDisable = true;
    this.type = 'edit';
    // this.celService.tracksFromTable = this.tracks;
    // this.celService.instanceList = this.instanceList;
    // this.celService.instanceName = this.selectedInstance;
    // // this.celService.tabval.next("submit");
    // // this.router.navigate(["../submit"], { relativeTo: this.route });

  }

}
